import { render, staticRenderFns } from "./platform_product_selector.vue?vue&type=template&id=7195daaf"
import script from "./platform_product_selector.vue?vue&type=script&lang=js"
export * from "./platform_product_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports